<template>
  <div class="container">
    <h1 class="title has-text-centered">โปรดเลือกช่องทางการชำระเงิน</h1>
      <b-field>
        <b-radio v-model="selectedMethod" size="is-medium" native-value="facebook-messenger" disabled>
          <i class="fab fa-facebook-messenger"></i> Facebook Messenger (ยังไม่เปิดใช้งาน)
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="selectedMethod" size="is-medium" native-value="line-pay" disabled>
          <i class="fab fa-line"></i> Line Pay (ยังไม่เปิดใช้งาน)
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="selectedMethod" size="is-medium" native-value="paypal" disabled>
          <i class="fab fa-paypal"></i> Paypal (ยังไม่เปิดใช้งาน)
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="selectedMethod" size="is-medium" native-value="truemoney" disabled>
          <i class="fas fa-wallet"></i> Truemoney wallet (ยังไม่เปิดใช้งาน)
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="selectedMethod" size="is-medium" native-value="credit-card" disabled>
          <i class="fas fa-credit-card"></i> Credit card (ยังไม่เปิดใช้งาน)
        </b-radio>
      </b-field>
      <b-field>
        <b-radio v-model="selectedMethod" size="is-medium" native-value="money-transfer">
          <i class="fas fa-money-check-alt"></i> โอนเงินผ่านบัญชี (Manual)
        </b-radio>
      </b-field>
      <button class="button is-primary" @click="submit" :class="{ 'is-loading': isLoading }" :disabled="selectedMethod === ''">Confirm</button>
      <h3 v-show="isLoading">กำลังสร้างหมายเลขรายการ... </h3>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'method',
    event: 'confirm'
  },
  props: {
    method: String
  },
  data () {
    return {
      selectedMethod: '',
      isLoading: false
    }
  },
  methods: {
    submit () {
      this.isLoading = true
      this.$emit('confirm', this.selectedMethod)
    }
  }
}
</script>

<style lang="scss">

</style>
